import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { X } from '@finect/tabular-icons/x';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var AdBlock = styled.div.withConfig({
  displayName: "partials__AdBlock",
  componentId: "sc-k2e7zt-0"
})(["display:block;position:fixed;z-index:350;top:85px;", " left:50%;border:1px solid ", ";border-radius:", ";margin:0 auto 48px;background:#fff;line-height:2em;text-align:center;transform:translate(-50%,0);&:before{content:'Publicidad';font-size:0.8em;color:", ";}iframe{z-index:351;}"], maxMediaQueries.tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["top: 100px;"]))), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.ui;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.uiMM;
});
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-k2e7zt-1"
})(["display:", ";margin:0 auto;", ""], function (_ref4) {
  var $open = _ref4.$open;
  return $open ? 'block' : 'none';
}, maxMediaQueries.tablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    > div {\n      margin-bottom: 0;\n    }\n  "]))));
export var StyledClose = styled.span.withConfig({
  displayName: "partials__StyledClose",
  componentId: "sc-k2e7zt-2"
})(["position:relative;top:8px;right:10px;float:right;cursor:pointer;color:", ";:hover{color:", ";}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.uiM;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.uiMM;
});
export var Close = function Close(_ref7) {
  var onClick = _ref7.onClick;
  return React.createElement(StyledClose, {
    onClick: onClick
  }, React.createElement(X, null));
};
export var AbsoluteInner = styled.div.withConfig({
  displayName: "partials__AbsoluteInner",
  componentId: "sc-k2e7zt-3"
})(["display:", ";position:relative;width:max-content;margin:0 auto;", ""], function (_ref8) {
  var $open = _ref8.$open;
  return $open ? 'block' : 'none';
}, maxMediaQueries.tablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    > div {\n      margin-bottom: 0;\n    }\n  "]))));
export var StyledAbsoluteClose = styled.div.withConfig({
  displayName: "partials__StyledAbsoluteClose",
  componentId: "sc-k2e7zt-4"
})(["position:absolute;right:1px;top:1px;height:15px;width:15px;cursor:pointer;color:", ";background:#fff;> svg{position:absolute;top:0;left:0;}:hover{color:", ";}"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.uiMM;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.uiDD;
});
export var AbsoluteClose = function AbsoluteClose(_ref11) {
  var onClick = _ref11.onClick;
  return React.createElement(StyledAbsoluteClose, {
    onClick: onClick
  }, React.createElement(X, {
    size: "16"
  }));
};